import React from 'react';
import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react';

// Shown where an appointment row arrives with `clinicalHidden: true`.
//
// The server empties a visit's notes, transcripts, OCR text, AI summary and
// media for anyone the clinical-record rule refuses — a receptionist holding
// appointments.view reads the diary, not the diagnosis — and flags the row
// (appointmentsForViewer, 15 Sep 2026). Rendering those emptied fields as they
// are would say "nothing was recorded", which is false. This says why they are
// not shown instead.
export default function ClinicalHiddenNote({ className = '', testId = 'clinical-hidden-note' }) {
    const { t } = useTranslation();
    return (
        <div
            role="note"
            data-testid={testId}
            className={`flex items-center gap-3 w-full rounded-2xl border border-[#C7D6D5] bg-[#9DB3B1]/10 px-4 py-3 ${className}`}
        >
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#4ABDBD]/15 text-[#2D8A8A]">
                <Lock className="h-4 w-4" aria-hidden="true" />
            </span>
            <p className="text-sm font-medium text-gray-600">
                {t('common.clinical_details_treating_doctor', 'Clinical details are visible to the treating doctor')}
            </p>
        </div>
    );
}
